export type PlatformMethodImplementation = {
  electron?: {
    send: string,
    listen?: string
  },
  maui?: string
}

export enum PlatformMethod {
  login = 'login',
  logout = 'logout',
  checkInstanceUpdateStatus = 'checkInstanceUpdateStatus',
  setInstanceUpdateStatus = 'setInstanceUpdateStatus',
  getFreeSpace = 'getFreeSpace',
  getIcn = 'getIcn',
  getModelFilters = 'getModelFilters',
  logError = 'logError',
  makeHttpGetRequest = 'makeHttpGetRequest',
  makeHttpRequest = 'makeHttpRequest',
  printDocument = 'printDocument',
  saveAsPdf = 'saveAsPdf',
  downloadInitialOfflineIndex = 'downloadInitialOfflineIndex',
  downloadInitialOfflineZips = 'downloadInitialOfflineZips',
  downloadOfflineResource = 'downloadOfflineResource',
  cancelLibraryActivate = 'cancelLibraryActivate',
  cancelLibraryUpdate = 'cancelLibraryUpdate',
  clearCache = 'clearCache'
}


export const platformMethodImplementations: {[key in PlatformMethod]: PlatformMethodImplementation} = {
  login: {
    electron: {
      send: 'nodeless-login'
    },
    maui: 'Authenticate'
  },
  logout: {
    maui: 'SignOut'
  },
  checkInstanceUpdateStatus: {
    electron: {
      send: 'api-get-is-update-triggered',
      listen: 'api-get-is-update-triggered-response'
    },
    maui: 'CheckInstanceUpdateStatus'
  },
  setInstanceUpdateStatus: {
    electron: {
      send: 'api-set-is-update-triggered'
    },
    maui: 'SetInstanceUpdateStatus'
  },
  getFreeSpace: {
    electron: {
      send: 'api-get-free-space',
      listen: 'api-get-free-space-response'
    },
    maui: 'GetFreeSpace'
  },
  getIcn: {
    electron: {
      send: 'getIcn',
      listen: 'getIcnResult'
    },
    maui: 'GetIcn'
  },
  getModelFilters: {
    electron: {
      send: 'getModelFilters',
      listen: 'getModelFiltersResult'
    },
    maui: 'GetModelFilters'
  },
  logError: {
    electron: {
      send: 'error-log'
    },
    maui: 'LogWebViewError'
  },
  makeHttpGetRequest: {
    maui: 'MakeHttpGetRequest'
  },
  makeHttpRequest: {
    maui: 'MakeHttpRequest'
  },
  printDocument: {
    maui: 'PrintDocument'
  },
  saveAsPdf: {
    maui: 'SaveAsPdf'
  },
  downloadInitialOfflineIndex: {
    maui: 'DownloadInitialOfflineIndex'
  },
  downloadInitialOfflineZips: {
    maui: 'DownloadInitialOfflineZips'
  },
  downloadOfflineResource: {
    maui: 'DownloadOfflineResource'
  },
  cancelLibraryActivate: {
    maui: 'CancelLibraryActivate'
  },
  cancelLibraryUpdate: {
    maui: 'CancelLibraryUpdate'
  },
  clearCache: {
    maui: 'ClearCache'
  }
}
